import {DataTreeNodeDTO} from "../data-tree-node-dto";

export class PrintCoutRevientPlatDTO {

  periode: Date[];
  dateProductionSelected: Date;
  dataTreeNodeDtoList: DataTreeNodeDTO[] = [];
  typeEffectif: string;
}
